export const membersId = ["king-willem-alexander", "queen-maxima", "princess-beatrix", "the-princess-of-orange",
    "princess-alexia", "princess-ariane", "prince-constantijn", "princess-laurentien", "princess-margriet"];